import { createSelector } from '@reduxjs/toolkit';
import { AvailableViewers } from 'common/enums/known-data-enums';
import { RootState } from '../../configureStore';

export const ipmFileSelector = ({ entities }: RootState) => {
  return entities.ipmFiles;
};

export const getIPMFilesSelector = createSelector(
  ipmFileSelector,
  (ipmFiles) => {
    return ipmFiles?.data?.map(file => ({
      ...file,
      objectid: file.id,
      data: file.value,
      type: file.type,
      metadata: {
        supportedViewers: [AvailableViewers.IPMFile],
      },
    }));
  },
);

export const getIPMFilesLoadingSelector = createSelector(
  ipmFileSelector,
  (ipmFiles) => {
    return ipmFiles?.isLoading;
  },
);
